export const M4_READING_PRACTICE = {
  id: "m4-reading-practice",
  title: "Reading Practice / Práctica de Lectura",
  topic: "Practice your reading comprehension! Five complete texts covering all Module 4 topics. Read carefully and answer questions to demonstrate your understanding. No grammar questions - just show you understand!",
  iconType: "book",
  
  sets: [
    // READING 1: Email - Personal Introduction & Routines (BÁSICO)
    {
      id: "m4-reading-1",
      title: "Reading 1: Hello from Toronto!",
      questions: [
        {
          type: "mc",
          q: "Lee el primer párrafo:\n\n**From: Sarah Martinez**\n**To: New Friends Group**\n**Subject: Hello from Toronto!**\n\nHi everyone! My name is Sarah and I'm 28 years old. I'm from Mexico City, but now I live in Toronto, Canada. I'm a graphic designer and I work at a small advertising company downtown. I'm not Canadian - I'm Mexican - but I love living here! I'm very excited to meet new people and practice my English!\n\nSarah is:",
          options: [
            "28 years old, from Mexico, lives in Toronto, works as a graphic designer",
            "From Toronto originally",
            "A student studying graphic design"
          ],
          a: "28 years old, from Mexico, lives in Toronto, works as a graphic designer",
          tip: "Basic information! Name, age, origin, current location, profession. All from introduction!"
        },
        {
          type: "mc",
          q: "Sarah says 'I'm a graphic designer' - this means:",
          options: [
            "This is her job/profession (what she does for work)",
            "She wants to be a designer in the future",
            "She's studying design"
          ],
          a: "This is her job/profession (what she does for work)",
          successtip: "✓ I'M A [job]! Present fact about profession! ⚠️ FALSE FRIEND: 'I'm embarrassed' = avergonzado (NOT embarazada = pregnant!)"
        },
        {
          type: "mc",
          q: "Sarah is 'excited' about meeting people - this means she feels:",
          options: [
            "Happy and enthusiastic (positive emotion)",
            "Worried and nervous (negative emotion)",
            "Angry"
          ],
          a: "Happy and enthusiastic (positive emotion)",
          tip: "EXCITED = positive! Happy, enthusiastic! Different from 'nervous' (worried)!"
        },
        {
          type: "mc",
          q: "Lee el segundo párrafo:\n\nMy daily routine is simple. I usually wake up at 7am and have breakfast at 7:30am. I go to work at 8:30am by subway - I don't drive because parking is very expensive in Toronto! I work from 9am to 5pm Monday to Friday. I don't work on weekends. I relax at home, visit friends, or go to the gym on Saturdays and Sundays.\n\nSarah's work schedule:",
          options: [
            "Works Monday to Friday, 9am-5pm, doesn't work weekends",
            "Works every day including weekends",
            "Works different hours every day"
          ],
          a: "Works Monday to Friday, 9am-5pm, doesn't work weekends",
          tip: "Work routine! Monday to Friday = weekdays. Saturday and Sunday = weekends = doesn't work!"
        },
        {
          type: "mc",
          q: "Sarah says 'I don't drive because parking is very expensive' - why doesn't she drive?",
          options: [
            "Parking costs too much money in Toronto",
            "She doesn't know how to drive",
            "She doesn't have a car"
          ],
          a: "Parking costs too much money in Toronto",
          successtip: "✓ REASON! Because = explanation! Parking expensive = reason for taking subway! ⚠️ 'Actually' = 'en realidad' (NOT 'actualmente' = currently/right now)!"
        },
        {
          type: "mc",
          q: "Sarah says 'I usually wake up at 7am' - 'usually' means:",
          options: [
            "This is her normal routine (most days)",
            "Only on Mondays",
            "Never"
          ],
          a: "This is her normal routine (most days)",
          tip: "USUALLY = routine! Most days, normally, regularly. Frequency adverb!"
        },
        {
          type: "mc",
          q: "Lee el tercer párrafo:\n\nRight now, I'm learning French because many people in Canada speak French, especially in Quebec. I'm also looking for new friends! Today, I'm not working - it's Saturday - so I'm writing this email and I'm relaxing at home. Later today, I'm meeting some friends at a café downtown. We're having coffee and practicing English together!\n\nSarah says 'I'm learning French' - this means:",
          options: [
            "She's studying French now (in progress, not finished)",
            "She speaks French perfectly",
            "French is her first language"
          ],
          a: "She's studying French now (in progress, not finished)",
          successtip: "✓ I'M LEARNING! Present continuous = in progress! Not finished yet! ⚠️ 'Library' = biblioteca (NOT librería = bookstore!)"
        },
        {
          type: "mc",
          q: "Sarah says 'Today, I'm not working' - why not?",
          options: [
            "Because it's Saturday (weekend - she doesn't work weekends)",
            "Because she's sick",
            "Because she's on vacation"
          ],
          a: "Because it's Saturday (weekend - she doesn't work weekends)",
          tip: "Connection to paragraph 2! She said 'I don't work on weekends' - today is Saturday!"
        },
        {
          type: "mc",
          q: "Sarah says 'I'm writing this email' - this means:",
          options: [
            "She's writing the email right now (at this moment)",
            "She writes emails every day as a routine",
            "She wrote the email yesterday"
          ],
          a: "She's writing the email right now (at this moment)",
          tip: "I'M WRITING = happening now! Present continuous = action at this moment!"
        },
        {
          type: "mc",
          q: "What is Sarah doing later today?",
          options: [
            "Meeting friends at a café, having coffee, practicing English",
            "Working at the office",
            "Staying home all day"
          ],
          a: "Meeting friends at a café, having coffee, practicing English",
          successtip: "Hey, un nativo tambien diria I'm hanging out with friends"
        },
        {
          type: "mc",
          q: "Comparing 'I usually wake up at 7am' and 'Today, I'm not working' - the difference is:",
          options: [
            "First = routine (every day). Second = today only (exception/specific day)",
            "Both are routines",
            "Both are happening right now"
          ],
          a: "First = routine (every day). Second = today only (exception/specific day)",
          tip: "Key difference! Present simple = routines/habits. Present continuous = now/today/temporary!"
        },
        {
          type: "mc",
          q: "Sarah's purpose for writing this email:",
          options: [
            "To introduce herself and meet new people (make friends)",
            "To find a new job",
            "To complain about Toronto"
          ],
          a: "To introduce herself and meet new people (make friends)",
          successtip: "✓ PURPOSE! She says 'excited to meet new people' and 'looking for new friends'! Clear intention! Email = friendly introduction to new group!"
        }
      ]
    },

    // READING 2: Blog Post - Feelings, Health & Weather (FÁCIL-MEDIO)
    {
      id: "m4-reading-2",
      title: "Reading 2: My Difficult Week",
      questions: [
        {
          type: "mc",
          q: "Lee el primer párrafo:\n\n**My Week - Blog Post by Carlos**\n\nWhat a terrible week! I'm feeling really frustrated right now. On Monday, I had a bad headache all day and my back hurt a lot. I didn't feel well, so I went to the doctor on Tuesday. The doctor said I'm stressed because I work too much. She's right - I am very stressed!\n\nCarlos is feeling:",
          options: [
            "Frustrated and stressed (negative emotions)",
            "Happy and excited (positive emotions)",
            "Calm and relaxed"
          ],
          a: "Frustrated and stressed (negative emotions)",
          tip: "NEGATIVE feelings! Frustrated = annoyed/unhappy. Stressed = too much pressure/worry!"
        },
        {
          type: "mc",
          q: "Carlos says 'I had a bad headache' - this means:",
          options: [
            "His head hurt (pain in the head)",
            "His stomach hurt",
            "He had a cold"
          ],
          a: "His head hurt (pain in the head)",
          successtip: "✓ HEADACHE = dolor de cabeza! Head hurts! ⚠️ 'Constipated' in English = estreñido (NOT constipado = cold/flu = 'I have a cold')!"
        },
        {
          type: "mc",
          q: "Why did Carlos go to the doctor?",
          options: [
            "Because he didn't feel well (headache and back pain)",
            "For a regular check-up",
            "Because he broke his leg"
          ],
          a: "Because he didn't feel well (headache and back pain)",
          tip: "REASON! Headache + back hurt = not feeling well = reason to see doctor!"
        },
        {
          type: "mc",
          q: "Lee el segundo párrafo:\n\nThe weather this week is terrible too! It's very cold and it's raining every day. I'm freezing! Yesterday, the temperature was only 2 degrees Celsius. Today is a bit warmer - it's 5 degrees - but it's still very cold and cloudy. I hate winter! I miss the warm, sunny weather of summer.\n\nThe weather this week:",
          options: [
            "Cold, rainy, and cloudy (bad weather)",
            "Hot and sunny",
            "Warm and beautiful"
          ],
          a: "Cold, rainy, and cloudy (bad weather)",
          tip: "BAD WEATHER! Cold, rain, clouds = terrible weather for Carlos!"
        },
        {
          type: "mc",
          q: "Carlos says 'I'm freezing' - this means:",
          options: [
            "He's very cold (extremely cold)",
            "He's very hot",
            "He's sick with a cold"
          ],
          a: "He's very cold (extremely cold)",
          successtip: "✓ FREEZING = very cold! Extreme cold! ⚠️ 'I have cold' ❌ WRONG! → 'I'm cold' ✓ (feeling) OR 'I have a cold' ✓ (illness)!"
        },
        {
          type: "mc",
          q: "Yesterday vs today - temperature:",
          options: [
            "Yesterday was colder (2°C), today is warmer (5°C)",
            "Yesterday was warmer than today",
            "Same temperature both days"
          ],
          a: "Yesterday was colder (2°C), today is warmer (5°C)",
          tip: "COMPARISON! 2 degrees vs 5 degrees. Today 'a bit warmer' but still cold!"
        },
        {
          type: "mc",
          q: "Lee el tercer párrafo:\n\nBut today is Friday, and I'm feeling better! My headache is gone and my back doesn't hurt anymore. I'm not working this weekend - I'm taking a break! Tomorrow, I'm sleeping late and I'm not doing anything stressful. On Sunday, I'm visiting my parents. They live in the countryside where it's peaceful and quiet. I'm really excited about relaxing this weekend!\n\nCarlos says 'I'm feeling better' - this means:",
          options: [
            "His health is improving (not sick anymore)",
            "He's feeling worse",
            "He's still very sick"
          ],
          a: "His health is improving (not sick anymore)",
          tip: "BETTER! Headache gone + back doesn't hurt = health improving!"
        },
        {
          type: "mc",
          q: "Carlos says 'I'm not working this weekend' - this means:",
          options: [
            "He's taking a break from work (no work Saturday and Sunday)",
            "He works every weekend",
            "He doesn't have a job"
          ],
          a: "He's taking a break from work (no work Saturday and Sunday)",
          successtip: "✓ TAKING A BREAK! Rest! No work! ⚠️ 'Sensible' in English = sensato/razonable (NOT sensible = sensitive!). 'Sensitive' = sensible!"
        },
        {
          type: "mc",
          q: "What is Carlos doing on Saturday?",
          options: [
            "Sleeping late and not doing anything stressful (relaxing)",
            "Working at the office",
            "Going to the doctor"
          ],
          a: "Sleeping late and not doing anything stressful (relaxing)",
          tip: "RELAXING! Sleep late = wake up late. Nothing stressful = rest/relax!"
        },
        {
          type: "mc",
          q: "Carlos's parents live:",
          options: [
            "In the countryside (peaceful and quiet area)",
            "In downtown Toronto",
            "In another country"
          ],
          a: "In the countryside (peaceful and quiet area)",
          tip: "COUNTRYSIDE! Not city! Peaceful and quiet = relaxing environment!"
        },
        {
          type: "mc",
          q: "Carlos's emotions change: beginning vs end of blog:",
          options: [
            "Beginning = frustrated and stressed. End = better and excited (improvement!)",
            "Same emotions throughout",
            "Beginning happy, end frustrated"
          ],
          a: "Beginning = frustrated and stressed. End = better and excited (improvement!)",
          successtip: "✓ EMOTIONAL CHANGE! Terrible week → feeling better! Story has progression! Bad → good!"
        },
        {
          type: "mc",
          q: "Main message of this blog:",
          options: [
            "Carlos had a difficult week but now feels better and is taking a relaxing weekend",
            "Carlos is always stressed",
            "Carlos hates his job"
          ],
          a: "Carlos had a difficult week but now feels better and is taking a relaxing weekend",
          successtip: "✓ MAIN IDEA! Problem (stress, bad weather, sickness) → Solution (rest, weekend, visit parents). Complete story with happy ending!"
        }
      ]
    },

    // READING 3: Travel Diary - Transportation & Travel (MEDIO)
    {
      id: "m4-reading-3",
      title: "Reading 3: My Business Trip to Vancouver",
      questions: [
        {
          type: "mc",
          q: "Lee el primer párrafo:\n\n**Travel Diary - Day 1**\n\nI usually drive to work every day, but this week is different! I'm on a business trip in Vancouver. I flew here by plane yesterday - the flight was 5 hours from Toronto. I don't usually fly - I prefer trains - but flying is faster for long distances. I arrived at Vancouver airport at 8pm and took a taxi to my hotel downtown.\n\nThe writer usually goes to work by:",
          options: [
            "Car (he drives)",
            "Plane",
            "Taxi"
          ],
          a: "Car (he drives)",
          tip: "ROUTINE! 'Usually drive to work' = normal routine. This week = different/exception!"
        },
        {
          type: "mc",
          q: "How did he travel to Vancouver?",
          options: [
            "By plane (flew - 5 hours from Toronto)",
            "By train",
            "By car"
          ],
          a: "By plane (flew - 5 hours from Toronto)",
          successtip: "✓ BY PLANE! 'Flew' = past form (you don't know yet!), but context shows airplane! ⚠️ 'Suburb' in English = nice residential area (NOT suburbio = poor area)!"
        },
        {
          type: "mc",
          q: "Why did he fly instead of taking a train?",
          options: [
            "Because flying is faster for long distances (Toronto to Vancouver is far)",
            "Because he loves flying",
            "Because trains don't exist"
          ],
          a: "Because flying is faster for long distances (Toronto to Vancouver is far)",
          tip: "REASON! Prefers trains BUT flying is faster = practical choice for long trip!"
        },
        {
          type: "mc",
          q: "Lee el segundo párrafo:\n\n**Day 2**\n\nToday, I'm not driving or taking taxis. I'm using public transportation! Vancouver has excellent buses and a great train system called SkyTrain. This morning, I took the SkyTrain to my meeting downtown. It's very convenient and much cheaper than taxis. Right now, I'm sitting on a bus going to the harbor. I want to see the ocean and visit Granville Island.\n\nToday, the writer is traveling by:",
          options: [
            "Public transportation (SkyTrain and bus)",
            "Car",
            "Taxi only"
          ],
          a: "Public transportation (SkyTrain and bus)",
          tip: "TODAY = exception! Not driving/taxis. Using SkyTrain (train) and bus instead!"
        },
        {
          type: "mc",
          q: "The writer says 'Right now, I'm sitting on a bus' - this means:",
          options: [
            "He's on the bus at this moment (writing while traveling)",
            "He takes the bus every day",
            "He took the bus yesterday"
          ],
          a: "He's on the bus at this moment (writing while traveling)",
          successtip: "✓ RIGHT NOW! Present continuous! He's writing his diary WHILE on the bus! Action happening at this moment!"
        },
        {
          type: "mc",
          q: "Why does he prefer SkyTrain?",
          options: [
            "It's convenient and much cheaper than taxis",
            "It's more expensive than taxis",
            "It's slower than walking"
          ],
          a: "It's convenient and much cheaper than taxis",
          tip: "REASONS! Convenient (easy to use) + cheaper = good advantages!"
        },
        {
          type: "mc",
          q: "Lee el tercer párrafo:\n\n**Day 3**\n\nYesterday, I walked a lot! Vancouver is a beautiful city for walking. Today, I'm renting a bicycle because I want to ride along the seawall - it's a famous bike path next to the ocean. I don't usually ride bikes at home in Toronto, but today I'm trying something new! Later, I'm meeting my colleague and we're taking a ferry to Victoria Island. I'm really enjoying this trip!\n\nComparing routines: Toronto vs Vancouver:",
          options: [
            "Toronto = drives car. Vancouver = walks, uses bikes, takes public transit (different!)",
            "Same transportation in both cities",
            "He never uses transportation"
          ],
          a: "Toronto = drives car. Vancouver = walks, uses bikes, takes public transit (different!)",
          successtip: "✓ CONTRAST! Routine (Toronto) vs exception (Vancouver trip). Trying different transportation! ⚠️ 'Parentes' = parents (NOT parientes = relatives!)"
        },
        {
          type: "mc",
          q: "The writer says 'I don't usually ride bikes at home' - this means:",
          options: [
            "In Toronto, he doesn't ride bikes normally (but trying it in Vancouver)",
            "He rides bikes every day in Toronto",
            "He can't ride a bike"
          ],
          a: "In Toronto, he doesn't ride bikes normally (but trying it in Vancouver)",
          tip: "EXCEPTION! 'Don't usually' = not his routine. BUT today = trying something new!"
        },
        {
          type: "mc",
          q: "What is the seawall?",
          options: [
            "A famous bike path next to the ocean",
            "A type of transportation",
            "A hotel"
          ],
          a: "A famous bike path next to the ocean",
          tip: "SEAWALL = bike path! Next to ocean = scenic route for biking!"
        },
        {
          type: "mc",
          q: "The writer and his colleague are taking:",
          options: [
            "A ferry (boat) to Victoria Island",
            "A plane",
            "A car"
          ],
          a: "A ferry (boat) to Victoria Island",
          successtip: "✓ FERRY! Boat transportation! To island = need boat! ⚠️ 'Carpet' in English = alfombra (NOT carpeta = folder!)"
        },
        {
          type: "mc",
          q: "How does the writer feel about the trip?",
          options: [
            "He's really enjoying it (positive - having a good time)",
            "He hates it",
            "He's bored"
          ],
          a: "He's really enjoying it (positive - having a good time)",
          tip: "ENJOYING! Positive emotion! Having a good experience! Trying new things!"
        },
        {
          type: "mc",
          q: "Main point of this travel diary:",
          options: [
            "Business trip to Vancouver - trying different transportation methods (plane, taxi, SkyTrain, bus, walking, bicycle, ferry)",
            "He only drives cars",
            "He doesn't like traveling"
          ],
          a: "Business trip to Vancouver - trying different transportation methods (plane, taxi, SkyTrain, bus, walking, bicycle, ferry)",
          successtip: "✓ VARIETY! Many transportation types! Contrasting routine (drive car) with trip (trying everything!). Shows flexibility and adventure!"
        }
      ]
    },

    // READING 4: Online Review - Comparisons & Geography (MEDIO-ALTO)
    {
      id: "m4-reading-4",
      title: "Reading 4: Comparing Canadian Cities",
      questions: [
        {
          type: "mc",
          q: "Lee el primer párrafo:\n\n**Review: Best Cities to Visit in Canada**\n**By: TravelExpert2025**\n\nI visited three Canadian cities this year: Toronto, Montreal, and Vancouver. All three are beautiful, but they're very different! Toronto is the biggest city with 3 million people. It has the CN Tower, the tallest structure in Canada. Toronto is more expensive than Montreal but cheaper than Vancouver. The weather is cold in winter - very cold!\n\nToronto is described as:",
          options: [
            "The biggest city (3 million people), has tallest structure (CN Tower), expensive, cold winters",
            "The smallest city",
            "The cheapest city"
          ],
          a: "The biggest city (3 million people), has tallest structure (CN Tower), expensive, cold winters",
          tip: "SUPERLATIVE! 'Biggest' and 'tallest' = extremes! Toronto = largest city!"
        },
        {
          type: "mc",
          q: "The writer says 'Toronto is more expensive than Montreal but cheaper than Vancouver' - this means:",
          options: [
            "Vancouver = most expensive, Toronto = middle, Montreal = cheapest",
            "Toronto is the most expensive",
            "Montreal is the most expensive"
          ],
          a: "Vancouver = most expensive, Toronto = middle, Montreal = cheapest",
          successtip: "✓ COMPARISON ORDER! 3 cities compared! Montreal < Toronto < Vancouver (price). Toronto in the middle!"
        },
        {
          type: "mc",
          q: "The CN Tower is:",
          options: [
            "The tallest structure in Canada (superlative - #1)",
            "Shorter than other buildings",
            "Not in Toronto"
          ],
          a: "The tallest structure in Canada (superlative - #1)",
          tip: "THE TALLEST! Superlative = #1! Highest structure in the country!"
        },
        {
          type: "mc",
          q: "Lee el segundo párrafo:\n\nMontreal is smaller than Toronto but more interesting culturally. It's the most French city in Canada - many people speak French here! The food is better than Toronto - Montreal has the best restaurants in Canada! The Old Montreal area is the most beautiful historic district I've ever seen. Montreal is colder than Toronto in winter, and it has more snow.\n\nMontreal is special because:",
          options: [
            "Most French, best food/restaurants, most beautiful historic area (superlatives!)",
            "It's the biggest city",
            "It's the warmest city"
          ],
          a: "Most French, best food/restaurants, most beautiful historic area (superlatives!)",
          successtip: "✓ MULTIPLE SUPERLATIVES! 'Most French', 'best restaurants', 'most beautiful' = Montreal's #1 qualities! Each city has different 'bests'!"
        },
        {
          type: "mc",
          q: "Comparing food: Toronto vs Montreal:",
          options: [
            "Montreal food is better than Toronto (comparative)",
            "Toronto food is better",
            "Same quality food"
          ],
          a: "Montreal food is better than Toronto (comparative)",
          tip: "BETTER! Irregular comparative! Good → better. Montreal wins for food!"
        },
        {
          type: "mc",
          q: "Comparing winter weather: Montreal vs Toronto:",
          options: [
            "Montreal is colder and has more snow (worse weather)",
            "Montreal is warmer",
            "Same weather"
          ],
          a: "Montreal is colder and has more snow (worse weather)",
          tip: "COMPARATIVE! Colder + more snow = Montreal winter more extreme than Toronto!"
        },
        {
          type: "mc",
          q: "Lee el tercer párrafo:\n\nVancouver is different from the other cities! It's on the coast next to the Pacific Ocean. It has beautiful mountains and beaches. The nature is better here than in Toronto or Montreal. It's the most expensive city, but it has the best weather - winters are warmer than the other cities! Vancouver has rainforests, islands, and you can see the ocean from downtown. For nature lovers, Vancouver is the best choice!\n\nVancouver's geography:",
          options: [
            "On the coast, has ocean, mountains, beaches, rainforests, islands",
            "In the middle of the country",
            "Has no nature"
          ],
          a: "On the coast, has ocean, mountains, beaches, rainforests, islands",
          tip: "GEOGRAPHICAL FEATURES! Coast, ocean, mountains, beaches, rainforests, islands = diverse geography!"
        },
        {
          type: "mc",
          q: "Vancouver weather compared to Toronto and Montreal:",
          options: [
            "Warmer winters (best weather)",
            "Colder winters (worst weather)",
            "Same weather"
          ],
          a: "Warmer winters (best weather)",
          successtip: "✓ WARMEST! Vancouver = mildest winters! On coast = ocean moderates temperature. Montreal coldest, Toronto middle, Vancouver warmest!"
        },
        {
          type: "mc",
          q: "Vancouver is 'the most expensive city' - this means:",
          options: [
            "Vancouver costs more than Toronto and Montreal (highest prices)",
            "Vancouver is the cheapest",
            "All cities cost the same"
          ],
          a: "Vancouver costs more than Toronto and Montreal (highest prices)",
          tip: "MOST EXPENSIVE! Superlative! Vancouver = highest cost of living of the three!"
        },
        {
          type: "mc",
          q: "For people who love nature, which city is best?",
          options: [
            "Vancouver (has the best nature - mountains, ocean, rainforests, islands)",
            "Toronto",
            "Montreal"
          ],
          a: "Vancouver (has the best nature - mountains, ocean, rainforests, islands)",
          tip: "BEST FOR NATURE! Context matters! Each city is 'best' for different things!"
        },
        {
          type: "mc",
          q: "Comparing all three cities - what's different?",
          options: [
            "Each city is 'the best' at something different (size, culture/food, nature/weather)",
            "All cities are exactly the same",
            "Only one city is good"
          ],
          a: "Each city is 'the best' at something different (size, culture/food, nature/weather)",
          successtip: "✓ DIFFERENT STRENGTHS! Toronto = biggest. Montreal = best culture/food. Vancouver = best nature/weather. No single 'best' city overall!"
        },
        {
          type: "mc",
          q: "Main message of this review:",
          options: [
            "All three cities are beautiful but different - best choice depends on what you want (size, culture, or nature)",
            "Only Vancouver is good",
            "All cities are bad"
          ],
          a: "All three cities are beautiful but different - best choice depends on what you want (size, culture, or nature)",
          successtip: "✓ BALANCED REVIEW! Uses many comparatives and superlatives to show differences! 'Best' depends on priority! Real comparison writing!"
        }
      ]
    },

    // READING 5: Text Conversation - Decisions & Choices (ALTO)
    {
      id: "m4-reading-5",
      title: "Reading 5: Planning a Vacation",
      questions: [
        {
          type: "mc",
          q: "Lee la primera parte de la conversación:\n\n**Text Messages**\n\n**Emma:** Hey! We need to decide our vacation! Which destination do you prefer - beach or mountains?\n\n**Carlos:** That's hard! I like both! But which is better for relaxing?\n\n**Emma:** I think beaches are better for relaxing. Mountains are good for hiking.\n\n**Carlos:** You're right. What about Costa Rica or Mexico? Which is cheaper?\n\nEmma asks 'Which destination' because:",
          options: [
            "She's offering two specific options (beach OR mountains - limited choice)",
            "She's asking an open question with no options",
            "She already decided"
          ],
          a: "She's offering two specific options (beach OR mountains - limited choice)",
          tip: "WHICH = specific options! Beach OR mountains = two clear choices = use WHICH!"
        },
        {
          type: "mc",
          q: "Carlos says 'I like both' - this means:",
          options: [
            "He likes beaches AND mountains (not choosing - likes the two options together)",
            "He likes only beaches",
            "He likes only mountains"
          ],
          a: "He likes beaches AND mountains (not choosing - likes the two options together)",
          successtip: "✓ BOTH! Means 'the two together'! Not choosing one - expressing he likes BOTH options! ⚠️ 'Exit' = salida (NOT éxito = success!)"
        },
        {
          type: "mc",
          q: "Emma says 'beaches are better for relaxing' - she means:",
          options: [
            "Beaches are more relaxing than mountains (comparative - comparing two)",
            "Beaches are the worst",
            "Mountains are more relaxing"
          ],
          a: "Beaches are more relaxing than mountains (comparative - comparing two)",
          tip: "BETTER! Irregular comparative! Good → better. Comparing beaches vs mountains!"
        },
        {
          type: "mc",
          q: "Lee la segunda parte:\n\n**Emma:** Costa Rica is $2,000 per person. Mexico is $1,500. So Mexico is cheaper!\n\n**Carlos:** Good! But which has better weather in July?\n\n**Emma:** Both have good weather! But Mexico is hotter than Costa Rica. Costa Rica is rainier.\n\n**Carlos:** I prefer hot and sunny! Is Mexico the best option then?\n\nMexico costs:",
          options: [
            "$1,500 (cheaper than Costa Rica's $2,000)",
            "More than Costa Rica",
            "The same as Costa Rica"
          ],
          a: "$1,500 (cheaper than Costa Rica's $2,000)",
          tip: "CHEAPER! Comparative! $1,500 < $2,000. Mexico = lower price!"
        },
        {
          type: "mc",
          q: "Comparing weather: Mexico vs Costa Rica in July:",
          options: [
            "Mexico is hotter (more sun). Costa Rica is rainier (more rain)",
            "Same weather",
            "Costa Rica is hotter"
          ],
          a: "Mexico is hotter (more sun). Costa Rica is rainier (more rain)",
          successtip: "✓ COMPARATIVES! Hotter vs rainier. Different weather patterns! Both good but different characteristics!"
        },
        {
          type: "mc",
          q: "Carlos asks 'Is Mexico the best option?' because:",
          options: [
            "It's cheaper AND has the weather he prefers (hot and sunny)",
            "It's the most expensive",
            "It has bad weather"
          ],
          a: "It's cheaper AND has the weather he prefers (hot and sunny)",
          tip: "BEST = superlative! Mexico meets both criteria: cheaper + hotter/sunnier = best for Carlos!"
        },
        {
          type: "mc",
          q: "Lee la tercera parte:\n\n**Emma:** I think so! But what about activities? Which has more to do?\n\n**Carlos:** Both have beaches and good food. Costa Rica has rainforests and volcanoes. Mexico has Mayan ruins.\n\n**Emma:** I want to see ancient ruins! That's the most interesting thing for me!\n\n**Carlos:** Perfect! So Mexico is the best for us - cheaper, better weather, AND ruins!\n\n**Emma:** I agree! Either we go to Cancun or we go to Playa del Carmen. Which do you prefer?\n\n**Carlos:** Let's go to both! We can split the trip!\n\nWhat activities does Costa Rica have?",
          options: [
            "Rainforests and volcanoes",
            "Mayan ruins",
            "No activities"
          ],
          a: "Rainforests and volcanoes",
          tip: "COSTA RICA = rainforests + volcanoes. MEXICO = Mayan ruins. Different attractions!"
        },
        {
          type: "mc",
          q: "Emma says 'That's the most interesting thing for me' - she means:",
          options: [
            "Ancient ruins are the most interesting (superlative - #1 priority for her)",
            "Ruins are boring",
            "Everything is interesting"
          ],
          a: "Ancient ruins are the most interesting (superlative - #1 priority for her)",
          successtip: "✓ MOST INTERESTING! Superlative expressing personal opinion! #1 thing she wants to see! Personal priority!"
        },
        {
          type: "mc",
          q: "Why is Mexico 'the best' for them?",
          options: [
            "It combines three good things: cheaper, better weather, AND has ruins (Emma's priority)",
            "It's only about price",
            "It's the most expensive"
          ],
          a: "It combines three good things: cheaper, better weather, AND has ruins (Emma's priority)",
          tip: "BEST = combination! Not just one factor. Meets multiple criteria = best overall choice!"
        },
        {
          type: "mc",
          q: "Emma says 'Either we go to Cancun or we go to Playa del Carmen' - this means:",
          options: [
            "Choose one of the two cities (uno u otro - not both)",
            "Go to both cities",
            "Go to neither city"
          ],
          a: "Choose one of the two cities (uno u otro - not both)",
          successtip: "✓ EITHER...OR! Choice structure! One or the other! Pick one option! ⚠️ BUT Carlos changes the plan..."
        },
        {
          type: "mc",
          q: "Carlos says 'Let's go to both!' - he's suggesting:",
          options: [
            "Visit Cancun AND Playa del Carmen (not choosing - visiting both cities)",
            "Visit only Cancun",
            "Visit only Playa del Carmen"
          ],
          a: "Visit Cancun AND Playa del Carmen (not choosing - visiting both cities)",
          tip: "BOTH! Not choosing one! Visit the two cities together! Split trip = divide time between both!"
        },
        {
          type: "mc",
          q: "This conversation shows decision-making process:",
          options: [
            "Start with options → compare (which is better/cheaper?) → find best combination → make final decision",
            "Random choice with no thinking",
            "They never decide"
          ],
          a: "Start with options → compare (which is better/cheaper?) → find best combination → make final decision",
          successtip: "✓ COMPLETE DECISION PROCESS! Uses WHICH vs WHAT, OR for choices, AND for combining, comparatives (better, cheaper, hotter), superlatives (best, most interesting), either...or, both...and. ALL Unit 18 structures naturally integrated! Real conversation shows how native speakers make decisions! 🎯✅"
        }
      ]
    }
  ]
};
